var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVaniLogoFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 29,
    viewBox: "0 0 125 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7851_4124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9542 23.5209V29.0003H15.8021C15.1416 29.0003 14.4946 28.9654 13.861 28.8902C13.8423 28.8902 13.8261 28.8902 13.8074 28.8876C6.02176 27.9828 0 21.8671 0 14.4547C0 9.28665 2.92899 4.74953 7.34262 2.16954L15.0826 23.3517C15.5121 24.5249 16.6316 25.3089 17.8854 25.3089H21.1983C22.4494 25.3089 23.5689 24.5276 23.9984 23.3517C24.1864 22.8336 24.9542 22.9705 24.9542 23.5209ZM13.9926 0.0137402L18.7499 16.0789C18.9351 16.734 19.8613 16.7393 20.0519 16.0843L24.9542 0.123812V0.0835421C22.5567 0.0808574 15.2114 -0.0399536 13.9926 0.0137402Z",
    fill: "url(#paint0_linear_7851_4124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8378 25.48L34.1152 4.20117H36.9959L44.3627 22.9081L51.7697 4.20117H54.4866L45.7641 25.48H42.8432H42.8378Z",
    fill: "#0E0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5802 25.7439C69.0715 25.7439 67.6915 25.4432 66.4458 24.8445C65.1974 24.2459 64.1263 23.4431 63.2349 22.4337C62.3436 21.4269 61.651 20.2564 61.157 18.9221C60.663 17.5878 60.416 16.1999 60.416 14.7555C60.416 13.3111 60.6684 11.8346 61.1785 10.4868C61.6859 9.13913 62.3919 7.96055 63.2967 6.95379C64.2014 5.94703 65.2592 5.14968 66.4646 4.56442C67.6727 3.97915 68.9748 3.68652 70.3735 3.68652C72.1857 3.68652 73.7831 4.14292 75.1684 5.05571C76.5537 5.96851 77.6437 7.13098 78.441 8.54849V4.22078H81.2385V25.3358H78.441V21.0484C77.6437 22.4632 76.5698 23.6015 75.2113 24.458C73.8529 25.3144 72.3092 25.7439 70.5829 25.7439H70.5802ZM78.441 11.6117C78.1376 10.8224 77.7349 10.0949 77.2275 9.42639C76.7201 8.76058 76.151 8.18069 75.5201 7.68939C74.8892 7.20078 74.1965 6.81955 73.4421 6.54572C72.6877 6.27456 71.8984 6.13764 71.0769 6.13764C69.9252 6.13764 68.8674 6.39 67.909 6.89204C66.9479 7.39676 66.1263 8.0572 65.4391 8.87334C64.7518 9.68949 64.2256 10.6157 63.8551 11.652C63.4846 12.6856 63.2994 13.7219 63.2994 14.7555C63.2994 15.8992 63.49 16.9892 63.8766 18.0228C64.2605 19.059 64.8028 19.9638 65.5035 20.7397C66.2042 21.5155 67.0338 22.1357 67.9922 22.5975C68.9506 23.0592 70.0084 23.2928 71.1601 23.2928C72.8891 23.2928 74.3764 22.7881 75.6248 21.7813C76.8732 20.7746 77.8128 19.5342 78.4437 18.0657V11.6117H78.441Z",
    fill: "#0E0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.446 25.8478H107.649V13.9627C107.649 11.431 107.27 9.59203 106.516 8.44835C105.761 7.30467 104.602 6.73283 103.039 6.73283C102.215 6.73283 101.393 6.88318 100.569 7.18118C99.745 7.48186 98.9852 7.90336 98.2845 8.44835C97.5865 8.99334 96.9609 9.64035 96.4133 10.3894C95.8629 11.1384 95.4656 11.9492 95.2213 12.819V25.8478H92.4238V4.56897H94.9743V9.38799C95.8522 7.83624 97.1059 6.58517 98.7409 5.62943C100.373 4.67636 102.148 4.20117 104.07 4.20117C105.249 4.20117 106.25 4.41863 107.074 4.85355C107.896 5.28847 108.556 5.90058 109.05 6.69256C109.544 7.48186 109.901 8.44835 110.121 9.59203C110.341 10.7357 110.452 12.0029 110.452 13.3909V25.8478H110.446Z",
    fill: "#0E0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.69 4.20117H121.893V25.8478H124.69V4.20117Z",
    fill: "#0E0F0F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7851_4124",
    x1: -2.0162,
    y1: 27.2177,
    x2: 18.9942,
    y2: 13.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E9282A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F1592D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7851_4124"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124.693,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaniLogoFull);
export default __webpack_public_path__ + "static/media/vani-logo-full.da5e8cc1bd149abf17579ee38b7354b2.svg";
export { ForwardRef as ReactComponent };